module.exports = __webpack_public_path__ + "static/media/v3logoLight.ff06d828.svg";